import { generateMedia } from 'styled-media-query';

const customMedia = generateMedia({
  small: '360px',
  medium: '768px',
  large: '1024px',
  xlarge: '1200px',
  xxlarge: '1366px'
});

export default customMedia;

// Importar dónde se vaya a utilizar
// import customMedia from '../../../config/themes/variables/breakpoints';

// Referencias:
// lessThan    = (max-width)
// greaterThan = (min-width)
// between     = (max-width) and (min-width)

// Ejemplo lessThan:
// ${customMedia.lessThan('large')`
// @content `}
// > @media screen and (max-width: 1024px) {}
// Ejemplo greaterThan:
// ${customMedia.greaterThan('medium')`
// @content `}
// > @media screen and (min-width: 768px) {}
// Ejemplo between:
// ${customMedia.between('small', 'xlarge')`
// @content `}
// > @media screen and (min-width: 360px) and (max-width: 1200px) {}
// Mediaqueries personalizadas o con excepciones:
// ${customMedia.lessThan('968px')`
// @content `}
// > @media screen and (max-width: 968px) {}
